import Mock from 'mockjs';
import { isSSR } from '@gbi/shared/utils/common';

import './user';
import './message-box';

if (!isSSR) {
  Mock.setup({
    timeout: '500-1500',
  });
}
